export const ChartNoDataIcon = () => (
  <svg width='26' height='34' viewBox='0 0 26 34' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M0 10H5V34H0V10Z' fill='#94A3B8' />
    <path d='M21 21H26V34H21V21Z' fill='#94A3B8' />
    <rect x='10.4004' width='5' height='34' fill='#94A3B8' />
  </svg>
);
